export default "__VITE_ASSET__Cpko8I7U__"